import { type ControlGroupOption } from "@gravity-ui/uikit";
import { TOLGEE_SETTINGS } from "src/env";

export const languageOptions: ControlGroupOption[] =
  TOLGEE_SETTINGS.AVAILABLE_LANGUAGES.map((lang) => ({
    value: lang,
    content: lang.toUpperCase(),
  }));

export const iconByLanguage: Record<string, string> = {
  ru: "ru",
  en: "gb",
  zh: "cn",
};
